import { claudeConstants } from '../_constants';
import { claudeService } from '../_services';
import { alertActions } from '.';

export const claudeActions = {
  launch,
  history,
  logs,
  cancel,
  cancelBatch,
  retry,
  retryBatch,
  deleteBatch,
  delete: _delete
};

function launch(model, action, prompt, checked_items) {

  return dispatch => {
    dispatch(request());

    claudeService.launch(model, action, prompt, checked_items)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(id) { return { type: claudeConstants.LAUNCH_REQUEST, id } }
  function success(launch) { return { type: claudeConstants.LAUNCH_SUCCESS, launch } }
  function failure(error) { return { type: claudeConstants.LAUNCH_FAILURE, error } }
}

function history(api_params) {

  return dispatch => {
    dispatch(request());

    claudeService.history(api_params)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(claude_history) { return { type: claudeConstants.HISTORY_REQUEST, claude_history } }
  function success(claude_history) { return { type: claudeConstants.HISTORY_SUCCESS, claude_history } }
  function failure(error) { return { type: claudeConstants.HISTORY_FAILURE, error } }
}

function logs(api_params) {

  return dispatch => {
    dispatch(request());

    claudeService.logs(api_params)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(claude_logs) { return { type: claudeConstants.LOGS_REQUEST, claude_logs } }
  function success(claude_logs) { return { type: claudeConstants.LOGS_SUCCESS, claude_logs } }
  function failure(error) { return { type: claudeConstants.LOGS_FAILURE, error } }
}

function cancel(ids) {

  return dispatch => {
    dispatch(request({ ids }));

    claudeService.cancel(ids)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
            dispatch(alertActions.success('Claude cancel successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(cancel) { return { type: claudeConstants.CANCEL_REQUEST, cancel } }
  function success(cancel) { return { type: claudeConstants.CANCEL_SUCCESS, cancel } }
  function failure(error) { return { type: claudeConstants.CANCEL_FAILURE, error } }
}

function cancelBatch(batchId) {

  return dispatch => {
    dispatch(request());

    claudeService.cancelBatch(batchId)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
            dispatch(alertActions.success('Batch cancel successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(cancel_batch) { return { type: claudeConstants.CANCEL_BATCH_REQUEST, cancel_batch } }
  function success(cancel_batch) { return { type: claudeConstants.CANCEL_BATCH_SUCCESS, cancel_batch } }
  function failure(error) { return { type: claudeConstants.CANCEL_BATCH_FAILURE, error } }
}

function retry(batchId) {

  return dispatch => {
    dispatch(request());

    claudeService.retry(batchId)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
            dispatch(alertActions.success('Claude retry successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(retry) { return { type: claudeConstants.RETRY_BATCH_REQUEST, retry } }
  function success(retry) { return { type: claudeConstants.RETRY_BATCH_SUCCESS, retry } }
  function failure(error) { return { type: claudeConstants.RETRY_BATCH_FAILURE, error } }
}

function retryBatch(batchId) {

  return dispatch => {
    dispatch(request());

    claudeService.retryBatch(batchId)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
            dispatch(alertActions.success('Batch retry successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(retry_batch) { return { type: claudeConstants.RETRY_BATCH_REQUEST, retry_batch } }
  function success(retry_batch) { return { type: claudeConstants.RETRY_BATCH_SUCCESS, retry_batch } }
  function failure(error) { return { type: claudeConstants.RETRY_BATCH_FAILURE, error } }
}

function deleteBatch(batchId) {

  return dispatch => {
    dispatch(request());

    claudeService.deleteBatch(batchId)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
            dispatch(alertActions.success('Batch deleted successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(delete_batch) { return { type: claudeConstants.DELETE_BATCH_REQUEST, delete_batch } }
  function success(delete_batch) { return { type: claudeConstants.DELETE_BATCH_SUCCESS, delete_batch } }
  function failure(error) { return { type: claudeConstants.DELETE_BATCH_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    claudeService.delete(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(id));
            dispatch(alertActions.success('Claude deleted successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(id, response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(id) { return { type: claudeConstants.DELETE_REQUEST, id } }
  function success(id) { return { type: claudeConstants.DELETE_SUCCESS, id } }
  function failure(id, error) { return { type: claudeConstants.DELETE_FAILURE, id, error } }
}
